interface SVGProps {
  color: string;
  style: React.CSSProperties;
}

const SVG = ({ color, style }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <path
      d="M5.1814 1V11.8696"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M16.051 11.8691H5.1814"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M25.8333 1C39.6376 1 50.8333 12.1957 50.8333 26C50.8333 39.8043 39.6376 51 25.8333 51C12.0289 51 0.833252 39.8043 0.833252 26"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M5.22461 11.8696C9.72461 5.30435 17.2681 1 25.8333 1"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M26.9202 11.8701V27.0875"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M39.9636 27.0869H26.9202"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export default SVG;
